import { render } from "./OtherRegisterOptions.vue?vue&type=template&id=23cf656a&scoped=true"
import script from "./OtherRegisterOptions.vue?vue&type=script&lang=js"
export * from "./OtherRegisterOptions.vue?vue&type=script&lang=js"

import "./OtherRegisterOptions.vue?vue&type=style&index=0&id=23cf656a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23cf656a"]])

export default __exports__